export default "__VITE_ASSET__CVoimmEq__"